import React, { Component } from "react"
import { Loader, Dimmer } from "@jjordy/layout"

export interface LoaderProps {
  active?: boolean
  ms?: number
}

interface LoaderState {
  active: boolean
}

export default class DeferredLoader extends Component<LoaderProps, LoaderState> {
  public state = { active: false }
  public timer: any
  public componentDidMount() {
    if (this.props.active) {
      this.timedLoader()
    }
  }

  public timedLoader() {
    const { ms = 0 } = this.props
    this.timer = setTimeout(() => {
      this.setState({
        active: true
      })
    }, ms)
  }

  public componentDidUpdate(prevProps: LoaderProps) {
    if (this.props.active && !prevProps.active) {
      this.timedLoader()
    } else if (!this.props.active && prevProps.active) {
      clearTimeout(this.timer)
    }
  }

  public componentWillUnmount() {
    clearTimeout(this.timer)
  }
  public render() {
    const { active } = this.state
    return (
      <Dimmer active={active}>
        <Loader active={active} />
      </Dimmer>
    )
  }
}
